import mainConfig from "./config.json";
window.config = mainConfig;

export default mainConfig;